import Breadcrumb from "../components/Breadcrumb";
import CarListingStatusLayer from "../components/child/CarListingStatusLayer"

const CarListingPending = () => {
  return (
    <>
        {/* Breadcrumb */}
        <Breadcrumb title='Pending Car Listing' />

        {/* <AnnouncementLayer /> */}
        <CarListingStatusLayer approvalStatusFilter="pending" />
    </>
  );
};

export default CarListingPending;




